import { withProps } from 'recompose';
import config from '../../config';

export default withProps({
  urlPattern: config.urlPatterns.service,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithServicesUrlPattern.js